module.exports = __webpack_public_path__ + "static/media/29.dc8a281f.png";